export default __webpack_public_path__ + "static/media/forth.ac8789ea.png";